export default __webpack_public_path__ + "static/media/voucherGTS3.dafd9b22.jpg";